import { useDispatch } from "react-redux"
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect"
import { storeActivityIndicator } from "../../../../redux/reducers/authSlice"
import { LocationInformationModel } from "./LocationInformation"
import toast from "react-hot-toast";
import { GetConstantListResponse } from "../../../../models/response/constant/GetConstantListResponse";
import { ConstantService } from "../../../../services/ConstantService";
import { CountryService } from "../../../../services/CountryService";

interface Props {
    selected: LocationInformationModel
    setSelected: React.Dispatch<React.SetStateAction<LocationInformationModel>>
    text: string
    getDistricts: (_countyId: string) => Promise<CustomSingleSelectModel[]>
}

const LocationInformationComponent = ({
    selected,
    setSelected,
    text,
    getDistricts
}: Props) => {
    return (
        <div className="col-md-4">
            <div>
                <label htmlFor="exampleFormControlInput1" className="form-label required">{text} Ülkesi</label>

                <CustomSingleSelect
                    selectedValue={selected.selectedCountry}
                    onChange={async (selectedItem) => {
                        setSelected({
                            ...selected,
                            selectedCountry: selectedItem,
                            selectedCounty: undefined,
                            selectedDistrict: undefined,
                        })
                    }}
                    onMenuOpen={() => CountryService.getCountryList()}
                    labelName='name'
                    valueName='countryId'
                />
            </div>

            <div className="mt-5">
                <label htmlFor="exampleFormControlInput1" className="form-label required">{text} Şehri</label>

                <CustomSingleSelect
                    selectedValue={selected.selectedCounty}
                    onChange={async (selectedItem) => {
                        setSelected({
                            ...selected,
                            selectedCounty: selectedItem,
                            selectedDistrict: undefined,
                        })
                    }}
                    onMenuOpen={selected.selectedCountry ? () => ConstantService.getConstantList('COUNTY', selected.selectedCountry?.value) : undefined}
                    labelName='value'
                    valueName='constantId'
                />
            </div>

            <div className="mt-5">
                <label htmlFor="exampleFormControlInput1" className="form-label required">{text} İlçesi</label>

                <CustomSingleSelect
                    selectedValue={selected.selectedDistrict}
                    onChange={async (selectedItem) => {
                        setSelected({
                            ...selected,
                            selectedDistrict: selectedItem,
                        })
                    }}
                    onMenuOpen={selected.selectedCounty ? () => ConstantService.getConstantList('DISTRICT', selected.selectedCounty?.value) : undefined}
                    labelName='value'
                    valueName='constantId'
                />
            </div>
        </div>
    )
}

export default LocationInformationComponent;